<template>

  <div class="vflex">
    <div class="vflex-row-1">
    
       <div class="hflex">
        <div class="hflex-col-0 hflex-options" style="min-width: 260px">
    
          <div class="p-3"><strong>{{ $t('Profile') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              class="list-group-item list-group-item-action"
              to="/config">{{ $t('My profile') }}</router-link>
            <!--<router-link
              class="list-group-item list-group-item-action"
              to="/config/email-settings">{{ $t('E-mail settings') }}</router-link>-->
            <!--<router-link
              class="list-group-item list-group-item-action"
              to="/config/calendar-settings">{{ $t('Calendar settings') }}</router-link>-->
            <router-link
              class="list-group-item list-group-item-action"
              to="/config/security">{{ $t('Security') }}</router-link>
            <router-link
              class="list-group-item list-group-item-action"
              to="/config/notify">{{ $t('Notifications') }}</router-link>
            <router-link
              class="list-group-item list-group-item-action"
              to="/config/browser-extension"><img src="../../assets/img/browser-extension/icon-chrome-extensions.jpg" height="20"> {{ $t('Chrome Extension') }}</router-link>
          </nav>

          <div
            v-if="permissions.includes('manage_settings') || permissions.includes('manage_careerpages')"
            class="p-3"><strong>{{ $t('Account / Careers') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/account">{{ $t('Account') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/settings">{{ $t('Settings') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/domains">{{ $t('Domains') }}</router-link> 
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/apply-fields">{{ $t('Apply fields') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/social">{{ $t('Website / Social') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_careerpages')"
              class="list-group-item list-group-item-action"
              to="/config/careersite">{{ $t('Career site') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_careerpages')"
              class="list-group-item list-group-item-action"
              to="/config/careerpage">{{ $t('Career page') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/audit">{{ $t('Audit') }}</router-link>
          </nav>

          <div
            v-if="permissions.includes('manage_members')"
            class="p-3"><strong>{{ $t('Members') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_members')"
              class="list-group-item list-group-item-action"
              to="/config/member">{{ $t('Members') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_members')"
              class="list-group-item list-group-item-action"
              to="/config/role">{{ $t('Roles') }}</router-link>
          </nav>

          <div
            v-if="permissions.includes('manage_companies') || permissions.includes('manage_departaments') || permissions.includes('manage_settings')"
            class="p-3"><strong>{{ $t('Jobs/Requisitions') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_companies')"
              class="list-group-item list-group-item-action"
              to="/config/company">{{ $t('Companies') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_departaments')"
              class="list-group-item list-group-item-action"
              to="/config/departament">{{ $t('Departaments') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/approvalrule">{{ $t('Approval flow') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/cancel-reason">{{ $t('Cancel reasons') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/contract">{{ $t('Contrat types') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/requisition-template">{{ $t('Requisition templates') }}</router-link>
          </nav>

          <div
            v-if="permissions.includes('manage_settings')"
            class="p-3"><strong>{{ $t('Pipeline') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/tag">Tags</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/questionform">{{ $t('Questionnaires/Tests') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/videoform">{{ $t('Video forms') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/scoreform">Scorecards</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/source">{{ $t('Sources') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/stage">{{ $t('Stages') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/disqualify-reason">{{ $t('Disqualify reasons') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/templatemail">{{ $t('Email templates') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/templateapply">{{ $t('Application question templates') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_candidates')"
              class="list-group-item list-group-item-action"
              to="/config/share-candidate">{{ $t('Shared candidates') }}</router-link>
          </nav>

          <div
            v-if="permissions.includes('manage_settings')"
            class="p-3"><strong>{{ $t('Settings') }}</strong></div>

          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/integration">{{ $t('Integrations') }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/gdpr">{{ $t('GDPR')  }}</router-link>
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/diversity">{{ $t('Diversity') }}</router-link>
          </nav>
          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/custom-fields">{{ $t('Custom fields') }}</router-link>
          </nav>
          <!--<nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/dexport">{{ $t('Export data') }}</router-link>
          </nav>-->
          <nav class="list-group list-group-flush">
            <router-link
              v-if="permissions.includes('manage_settings')"
              class="list-group-item list-group-item-action"
              to="/config/dataimex">{{ $t('Import/Export') }}</router-link>
          </nav>

        </div>
        <div class="hflex-col-1">
          <router-view></router-view>
        </div>
      </div>  

    </div>
  </div>

</template>

<script>
export default {
  name: 'Config',
  data () {
    return {
    }
  },
  computed: {
    permissions () {
      return this.$store.getters.getPermissions
    }
  },
  metaInfo () {
    return {
      title: this.$t('Settings')
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .card-container{
    padding: 1em;
  }
</style>



// WEBPACK FOOTER //
// src/components/Config/Config.vue